import selectors from '../rootSelectors';
import { RAN_FETCH_RETRY } from '../common/api/apiRetryGetConstants';
import {
    blockScreen, unblockScreen, toggleCircleButtons, greyOutScreen, toggleSecondsTimer,
    activateNextButton, setSecondsTimer,
} from '../common/screen/screenActions';
import { playAvatarAudio, setAvatarInstructions } from '../common/avatar/avatarActions';
import RANServiceClient from '../common/clients/RANServiceClient';
import RAN_AUDIO_INSTRUCTIONS from './ranConstants';
import { postResult } from '../common/api/ranActions';
import { PRACTICE, ITEMS } from '../constants/assessmentItemType';

export const SET_RAN_CONTENT = 'SET_RAN_CONTENT';
export const NEXT_ITEM_ACTIVE_INDEX = 'NEXT_ITEM_ACTIVE_INDEX';
export const RESET_ITEM_ACTIVE_INDEX = 'RESET_ITEM_ACTIVE_INDEX';
export const CLEAR_ITEM_ACTIVE_INDEX = 'CLEAR_ITEM_ACTIVE_INDEX';
export const ADD_RAN_SELECTED_RESPONSE = 'ADD_RAN_SELECTED_RESPONSE';
export const RESET_RAN_SELECTED_RESPONSES = 'RESET_RAN_SELECTED_RESPONSES';
export const SET_TIME_DURATION = 'SET_TIME_DURATION';

export const setRANContent = (content) => ({
    type: SET_RAN_CONTENT,
    content,
});

export const nextItemActiveIndex = () => ({
    type: NEXT_ITEM_ACTIVE_INDEX,
});

export const resetItemActiveIndex = () => ({
    type: RESET_ITEM_ACTIVE_INDEX,
});

export const clearItemActiveIndex = () => ({
    type: CLEAR_ITEM_ACTIVE_INDEX,
});

export const addRANSelectedResponse = (response) => ({
    type: ADD_RAN_SELECTED_RESPONSE,
    response,
});

export const resetRANSelectedResponses = () => ({
    type: RESET_RAN_SELECTED_RESPONSES,
});

export const setTimeDuration = (timeDuration) => ({
    type: SET_TIME_DURATION,
    timeDuration,
});

const itemResponse = (itemId, outcome) => ({
    item_id: itemId,
    outcome,
});

const setNextItemActive = () => (dispatch) => {
    dispatch(blockScreen());
    dispatch(nextItemActiveIndex());
    dispatch(unblockScreen());
};

export const playPracticeScript = (measureType) => async (dispatch) => {
    const measureTypeAudio = RAN_AUDIO_INSTRUCTIONS[measureType];
    await dispatch(playAvatarAudio(measureTypeAudio.practiceInstructionStart));
    await measureTypeAudio.autoplayInstructions.reduce((promise, audio) => promise.then(async () => {
        await dispatch(playAvatarAudio(audio));
        dispatch(nextItemActiveIndex());
    }), Promise.resolve());
    dispatch(resetItemActiveIndex());
    return dispatch(playAvatarAudio(measureTypeAudio.practiceInstructionGeneral));
};

export const fetchRANContent = (measureType) => async (dispatch) => {
    const contentJson = await dispatch(RANServiceClient.getForm(measureType, RAN_FETCH_RETRY));
    if (contentJson instanceof Array) {
        dispatch(setRANContent(contentJson[0]));
    } else {
        dispatch(setRANContent(contentJson));
    }
};

export const onLastItemResponse = (measureType, pageType) => async (dispatch) => {
    const readyInstruction = RAN_AUDIO_INSTRUCTIONS[measureType].practiceReadyInstruction;
    const playPromise = (pageType === PRACTICE)
        ? dispatch(playAvatarAudio(readyInstruction))
        : Promise.resolve();

    dispatch(toggleSecondsTimer());
    dispatch(toggleCircleButtons());
    dispatch(clearItemActiveIndex());

    await playPromise;
    dispatch(setAvatarInstructions(readyInstruction));
    dispatch(activateNextButton());
    dispatch(unblockScreen());
};

export const addSelectedResponse = (itemId, selectedResponse) => (dispatch) => {
    const response = itemResponse(itemId, selectedResponse);

    dispatch(addRANSelectedResponse(response));
};

export const onPracticeItemResponse = (measureType) => (dispatch, getState) => {
    const state = getState();
    const itemIndex = selectors.getRANActiveItemIndex(state);
    const items = selectors.getRANItems(state, PRACTICE);
    const isLastQuestion = itemIndex === items.length - 1;

    if (!isLastQuestion) {
        return dispatch(setNextItemActive());
    }
    dispatch(greyOutScreen());
    return dispatch(onLastItemResponse(measureType, PRACTICE));
};

export const saveResult = (measureType) => (dispatch, getState) => {
    const state = getState();
    const formId = selectors.getRANFormId(state);
    const responses = selectors.getRANResponses(state);

    return dispatch(postResult(measureType, formId, responses));
};

export const onNextItemResponse = (measureType, selectedResponse, timeDuration) => async (dispatch, getState) => {
    const state = getState();
    const itemIndex = selectors.getRANActiveItemIndex(state);
    const items = selectors.getRANItems(state, ITEMS);
    const { itemId } = items[itemIndex];
    const isLastQuestion = itemIndex === items.length - 1;

    dispatch(addSelectedResponse(itemId, selectedResponse));
    dispatch(setSecondsTimer(false));
    if (!isLastQuestion) {
        return dispatch(setNextItemActive());
    }
    dispatch(greyOutScreen());
    dispatch(setTimeDuration(timeDuration));
    return dispatch(onLastItemResponse(measureType, ITEMS));
};
